/* istanbul ignore file */
export { default } from './LivePerson';
export { LivePerson } from './LivePerson';
